import { AlertBar, textLinkVariants } from '@civilgrid/ui/components';
import { Link } from '@tanstack/react-router';

export default function UnverifiedBanner() {
  return (
    <div data-testid="unverified-banner">
      <AlertBar
        variant="warning"
        icon="warning"
        layout="banner"
        title={
          <>
            Access is limited for unverified users.{' '}
            <Link to="/verification" className={textLinkVariants()} data-testid="unverified-banner-verify">
              Verify now
            </Link>
          </>
        }
      />
    </div>
  );
}
